import { Link, useRouterState } from "@tanstack/react-router";

const pillBase = "rounded-full px-3.5 py-1.5 text-sm transition-colors";
const pillActive = `${pillBase} bg-[var(--green)] font-semibold text-white`;
const pillInactive = `${pillBase} font-medium text-[var(--text-secondary)] hover:text-[var(--green)]`;

export function AccountSubNav() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const overviewActive = pathname === "/account" || pathname === "/account/";
  const ordersActive = pathname === "/orders";
  const addressesActive = pathname.startsWith("/account/addresses");
  const paymentActive = pathname.startsWith("/account/payment");
  const identityActive = pathname.startsWith("/account/identity");
  const supportActive = pathname.startsWith("/account/support");

  return (
    <nav className="mb-6 flex flex-wrap gap-2" aria-label="Account">
      <Link to="/account" className={overviewActive ? pillActive : pillInactive}>
        Overview
      </Link>
      <Link to="/orders" className={ordersActive ? pillActive : pillInactive}>
        Orders
      </Link>
      <Link to="/account/addresses" className={addressesActive ? pillActive : pillInactive}>
        Addresses
      </Link>
      <Link to="/account/payment" className={paymentActive ? pillActive : pillInactive}>
        Payment
      </Link>
      <Link to="/account/identity" className={identityActive ? pillActive : pillInactive}>
        Identity
      </Link>
      <Link to="/account/support" className={supportActive ? pillActive : pillInactive}>
        Contact support
      </Link>
    </nav>
  );
}
